/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GcpZone {
    getFixupPrototypeFunction() { return GcpZone.fixupPrototype; }

    static newInstance(model: Partial<GcpZone>): GcpZone {
        let obj = Object.assign(new GcpZone(), model);
        GcpZone.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GcpZone>): GcpZone {
        if (!model) return null;
        return GcpZone.newInstance(<GcpZone> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GcpZone) {
        if (!obj) return;

        models.GcpZone.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GcpZone): boolean {
        Object.setPrototypeOf(obj, GcpZone.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name for zone
     */
    name: string;

    /**
     * Id for zone
     */
    id: string;

}
